(function () {
  // Pause offscreen animations to save battery
  var animated = document.querySelectorAll('.bs-hero__orb, .bs-brands__track');
  if (animated.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
      });
    }, { rootMargin: '100px' });
    animated.forEach(function (t) { obs.observe(t); });
  }

  // Scroll-reveal: fade-up cards as they enter the viewport, staggered per row.
  // Classes are only ever added here, so without JS everything stays visible.
  var motionOK = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  if (motionOK && 'IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll(
      '.bs-video__player, .bs-video__chip, .bs-helpme__card, .bs-features__card, .bs-blog__card, .bs-newsletter__inner'
    );
    var siblingIndex = new Map();
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('bs-in');
        revealObs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    revealTargets.forEach(function (el) {
      var parent = el.parentNode;
      var idx = siblingIndex.get(parent) || 0;
      siblingIndex.set(parent, idx + 1);
      el.style.setProperty('--bs-reveal-delay', (Math.min(idx, 8) * 70) + 'ms');
      el.classList.add('bs-reveal');
      revealObs.observe(el);
    });
  }

  // Brands marquee: cursor-following tilt on logo cards (pointer devices only)
  var canTilt = window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)');
  if (canTilt.matches) {
    document.querySelectorAll('[data-bs-brand-logo]').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--tilt-y', (px * 10).toFixed(2) + 'deg');
        card.style.setProperty('--tilt-x', (py * -8).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  // Bundles: normalize data-state so exactly one panel is expanded on load.
  // Guards against merchant footgun — reordering blocks or checking "featured" on
  // zero/multiple panels would otherwise break the CSS hover-out state.
  document.querySelectorAll('[data-bs-bundle-strip]').forEach(function (strip) {
    var panels = strip.querySelectorAll('[data-bs-bundle-panel]');
    if (!panels.length) return;
    var expanded = strip.querySelectorAll('[data-bs-bundle-panel][data-state="expanded"]');
    if (expanded.length === 0) {
      panels[0].setAttribute('data-state', 'expanded');
    } else if (expanded.length > 1) {
      expanded.forEach(function (p, i) {
        p.setAttribute('data-state', i === 0 ? 'expanded' : 'collapsed');
      });
    }
  });

  // Bundle accordion: click-to-expand for touch and keyboard
  var panels = document.querySelectorAll('[data-bs-bundle-panel]');
  panels.forEach(function (panel) {
    var activate = function (e) {
      if (e.target.closest('a')) return; // don't hijack CTA clicks
      var strip = panel.closest('[data-bs-bundle-strip]');
      if (!strip) return;
      strip.querySelectorAll('[data-bs-bundle-panel]').forEach(function (p) {
        p.setAttribute('data-state', p === panel ? 'expanded' : 'collapsed');
      });
    };
    panel.addEventListener('click', activate);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(e); }
    });
  });
})();
